import * as _ from "lodash";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSplineChart from "../../../../../shared/custom-highchart-component/custom-spline-chart.component";
import CustomSpinnerComponent from "../../../../../shared/custom-spinner/custom-spinner.component";
import { getEnergyConsumptionData } from "../../../../../store/slices/asset.slice";
import { generateFilenameWithTimestamp } from "src/shared/helpers/generateFilenameWithTimestamp";
import ChipComponent from "src/core/components/chip/chip.component";

interface AssetDetailsEnergyConsumptionChartType {
  assetId: any;
  isRefreshed: boolean;
  assetDetails?: any;
}

const AssetDetailsEnergyConsumptionChart: FC<
  AssetDetailsEnergyConsumptionChartType
> = ({ assetId, isRefreshed, assetDetails }) => {
  const dispatch = useDispatch();

  const [energyConsumptionChartData, setEnergyConsumptionChartData] =
    useState<any>([]);

  const [savedEnergy, setSavedEnergy] = useState<number[]>([]);

  const [energyConsumptionBaselineValues, setEnergyConsumptionBaselineValues] =
    useState<any>([]);

  useEffect(() => {
    dispatch(getEnergyConsumptionData({ id: assetId }));
  }, [assetId, isRefreshed]);

  const isLoadingEnergyConsumptionData = useSelector((state: any) => {
    return state.asset.isLoadingEnergyConsumptionData;
  });

  const energyConsumptionData = useSelector((state: any) => {
    return state.asset.energyConsumptionData;
  });

  const checkAllValuesForNull = (arr: any[]) => {
    return arr?.every((value) => value === null) ? null : arr;
  };

  /*   const { data: energyConsumptionListByModule } = useQuery({
    queryKey: ["getBaselineListByModuleId", 2, assetId],
    queryFn: () =>
      getBaselineListByModuleId({
        baselineModuleId: 2,
        blockCode: null,
        assetCode: assetId,
      }),
  }); */

  useEffect(() => {
    if (energyConsumptionData?.data?.length) {
      /*       const isEveryEnergyConsumptionZero =
        energyConsumptionData?.data[0]?.energyConsumptionInWKH?.every(
          (data: any) => data == 0
        );

      if (isEveryEnergyConsumptionZero) {
        setEnergyConsumptionChartData([]);
      } else {
        setEnergyConsumptionChartData(
          _.cloneDeep(energyConsumptionData?.data[0]?.energyConsumptionInWKH)
        );
      } */

      setEnergyConsumptionBaselineValues(
        _.cloneDeep(
          energyConsumptionData?.data[0]?.energyConsumptionBaseline?.map(
            (val: any) => (val == 0 ? null : val)
          )
        )
      );

      if (
        checkAllValuesForNull(
          energyConsumptionData?.data[0]?.energyConsumptionInWKH
        )
      ) {
        setEnergyConsumptionChartData(
          _.cloneDeep(energyConsumptionData?.data[0]?.energyConsumptionInWKH)
        );
        setSavedEnergy(
          _.cloneDeep(energyConsumptionData?.data[0]?.savedEnergyInWKH)
        );
      } else {
        setEnergyConsumptionChartData([]);

        setSavedEnergy([]);
      }

      // setEnergyConsumptionChartData(
      //   _.cloneDeep(energyConsumptionData?.data[0]?.energyConsumptionInWKH)
      // );
    }
  }, [energyConsumptionData]);

  return (
    <div className="mt-4 ">
      <div>
        <h4 className="h4" style={{ marginBottom: "1rem" }}>
          Energy Consumption
          <span style={{ fontSize: "16px" }}>(Last 7 Days){assetDetails?.vendor == "ST Engineering" && <ChipComponent label="Estimated" />}</span>
        </h4>
      </div>

      <CustomSpinnerComponent
        height={"300px"}
        width={"100%"}
        isLoading={isLoadingEnergyConsumptionData}
      >
        <CustomSplineChart
          xAxisTitleText="Time (Date)"
          yAxisTitleText="Energy Consumption(Wh)"
          seriesData={energyConsumptionChartData}
          baseline={energyConsumptionBaselineValues}
          savedEnergy={savedEnergy}
          fileName={generateFilenameWithTimestamp(
            "Energy Consumption (Last 7 Days)"
          )}
          chartName={"Energy Consumption (Last 7 Days)"}
        />
      </CustomSpinnerComponent>
    </div>
  );
};

export default AssetDetailsEnergyConsumptionChart;
